export enum FeedbackCategory {
  TOURISMNFEE = 'Tourismnfee',
  BENEFITS = 'Benefits',
  COMMUNE = 'Commune',
  ERROR = 'Error',
  SUGGESTION = 'Suggestion',
}
